/**
 * Created by fers on 08/08/2017.
 */
import React from 'react';
import PropTypes from 'prop-types';

interface RefreshButtonProps {
    autoRefresh?: boolean;
    className?: string;
    fastRefresh?: boolean;
    relay: object;
}

export default class RefreshButton extends React.Component<RefreshButtonProps> {
    static propTypes = {
        autoRefresh: PropTypes.bool,
        className: PropTypes.string,
        fastRefresh: PropTypes.bool,
        relay: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            refreshInProgress: false
        };

        if (this.props.fastRefresh) {
            this.prolongConstant = 1000;
        } else {
            this.prolongConstant = 5000;
        }
    }

    _clearTimeout() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }

    rescheduleTimer() {
        this._clearTimeout();

        if (!this.props.autoRefresh) {
            return;
        }

        this.timer = setTimeout(() => {
            this.refresh();

            if (this.props.fastRefresh) {
                this.prolongConstant = this.prolongConstant * 1.2;
                if (this.prolongConstant > 9000) {
                    this.prolongConstant = 9000;
                }
            } else {
                this.prolongConstant = this.prolongConstant * 2.0;
                if (this.prolongConstant > 50000) {
                    this.prolongConstant = 50000;
                }
            }
        }, this.prolongConstant + 1000);
    }

    refresh = () => {
        this.rescheduleTimer();
        this.setState({refreshInProgress: true});

        return this.props.relay.forceFetch({}, (state) => {
            if (state.done || state.error) {
                this.setState({refreshInProgress: false});
            }
        });
    };

    componentDidMount() {
        this.refresh();
    }

    componentWillUnmount() {
        this._clearTimeout();
    }

    render() {
        return (
            <div className={"btn btn-default " + (this.props.className ? this.props.className : "")} onClick={this.refresh}><span className={"fa fa-refresh " + (this.state.refreshInProgress ? " fa-spin " : "")}/></div>
        );
    }

}
